import AxelDirty from './dirty.type';

export default class AxelType {
  private _originalValue: any;

  protected _newValue: any = void 0;

  static DIRTY = new AxelDirty();

  public constructor(value) {
    this._originalValue = value;
  }

  public original() {
    return this._originalValue;
  }

  public valueOf() {
    return this._newValue;
  }

  public valueOrNull() {
    if (this.original() === null) {
      return null;
    } else {
      return this.valueOf();
    }
  }

  protected setAsDirty() {
    this._newValue = AxelType.DIRTY;
  }

  static isDirty(o) {
    if (o === null || o === void 0) {
      return true;
    }
    if ('function' === typeof o.valueOf) {
      return o.valueOf() instanceof AxelDirty;
    } else {
      return o instanceof AxelDirty;
    }
  }

  public toString() {
    if (AxelType.isDirty(this.valueOf())) {
      if (this.original() === null || 'undefined' === typeof this.original()) {
        return String('');
      } else {
        return String(this.original());
      }
    } else {
      return String(this.valueOf());
    }
  }

  public toStringOrNull() {
    if (this.original() === null) {
      return null;
    } else {
      return this.toString();
    }
  }
}
